import { Component, Input, OnInit, ViewEncapsulation } from "@angular/core";
import { faEdit } from "@fortawesome/pro-light-svg-icons";
import { VAIconRegistryService, trash } from "@va/core-library/icons";

@Component({
  selector: "app-alert-grid-action-renderer",
  template: `
    <ng-template #alertsTemplate>
      <app-alerts-popover
        [params]="alertPopoverParams"
        (onSet)="onEditAlert()"
      ></app-alerts-popover>
    </ng-template>

    <ng-template #titleTemplate
      >Edit Alert ({{ alertPopoverTitle | textEllipsis: 23 }})</ng-template
    >

    <span class="alert-grid-action-renderer">
      <span class="edit-icon">
        <va-icon
          isFontAwesome="true"
          [name]="faEdit"
          title="Edit"
          nz-popover
          nzPopoverPlacement="left"
          nzPopoverTrigger="click"
          [nzPopoverTitle]="titleTemplate"
          nzPopoverOverlayClassName="alerts-popover-overlay-left"
          [nzPopoverContent]="alertsTemplate"
          [(nzPopoverVisible)]="showEditPopover"
        ></va-icon>
      </span>
      <span (click)="onDelete()" class="delete-icon" *ngIf="showDelete">
        <va-icon
          size="small"
          name="trash"
          nz-tooltip
          nz-tooltipTitle="Delete"
        ></va-icon>
      </span>
    </span>
  `,
  styles: [
    `
      .alert-grid-action-renderer .edit-icon {
        margin-right: 5px;
        cursor: pointer;
        color: #36abad;
      }
      .alert-grid-action-renderer .delete-icon {
        cursor: pointer;
        color: #36abad;
      }
      .alerts-popover-overlay-left .ant-popover-title {
        background-color: #bcc3c7;
        color: #fefffe;
      }
      .alerts-popover-overlay-left .ant-popover-inner-content {
        padding: 10px 10px 10px 5px;
        width: 260px;
      }
      .alerts-popover-overlay-left .ant-popover-arrow {
        display: none;
      }
    `,
  ],
  encapsulation: ViewEncapsulation.None,
})
export class AlertGridActionRendererComponent implements OnInit {
  @Input() dataObj;
  faEdit = faEdit;
  showEditPopover = false;
  showDelete = false;
  alertPopoverParams: any;
  alertPopoverTitle: string;

  constructor(private iconRegistry: VAIconRegistryService) {
    this.iconRegistry.registerIcons([trash]);
  }

  ngOnInit() {
    this.alertPopoverParams = {
      key: this.dataObj.id,
      type: this.dataObj.type,
    };

    this.alertPopoverTitle = this.dataObj.name || "";
    this.showDelete =
      this.alertPopoverParams.key === -1 &&
      this.alertPopoverParams.type === "watchlist"
        ? false
        : true;
  }

  onDelete() {
    this.dataObj.onDelete(this.dataObj.alertId);
  }

  onEditAlert() {
    this.dataObj.onEdit();
    this.showEditPopover = false;
  }
}
